<template>
    <div>
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">{{$t('noauth.access_code_label')}}</p>
        <el-form
            @submit.prevent.native="doLoginOTP('otpLoginForm')"
            class="px-4 sm:px-0"
            :model="otpLoginForm"
            :rules="otpLoginRules"
            ref="otpLoginForm"
            novalidate
        >
          <el-form-item  prop="codigo">
            <el-input
              :placeholder="$t('app.code')"
              type="codigo"
              class="mb-2 custom__icons static-css"
              clearable
              v-model="otpLoginForm.codigo"
              maxlength='6'
            >
              <i slot="prefix" class="el-input__icon">
                <BaseIcon size="sm"  name="lock" />
              </i>
            </el-input>
          </el-form-item>
          <base-button
          class="w-full"
          mode="staticprimary"
          :text="$t('noauth.common_access')"
          type="submit"
          :loading = "loader"
          />
        </el-form>
    </div>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  name: 'otp-login-form',
  data: function () {
    return {
      loader: false,
      otpLoginForm: {
        codigo: '',
      },
      otpLoginRules: {
        codigo: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur',
          }
        ],
      },
    }
  },
  methods: {
    doLoginOTP: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loader = true
            await this.$store.dispatch('auth/checkOTPLogin', { otpCode: this.otpLoginForm.codigo })
            await this.$store.dispatch('app/getAnnouncementsList')
          } catch (error) {
            if (error !== undefined && error.blnError) {
              this.doFeedback(`${error.msgError} [${error.codError}]`)
            } else {
              this.doFeedback()
            }
          } finally {
            this.loader = false
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
  }
}
</script>

<style scoped>
.dark .el-input .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>
